import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useAccount } from 'wagmi';
import { getFromApi } from '../../helpers/api';

const Discover = () => {
  const [results, setResults] = useState([]);
  const [collection, setCollection] = useState([]); 
  const { address, connector, isConnected } = useAccount(); 
  useEffect(() => {
    loadArtists();
    if(isConnected) {
      loadMyCollection();
    }
  }, []);

  const loadArtists = async () => {
    try {
      // const res = await fetch(`http://localhost:3000/artist`);
      // const json = await res.json();
      const json = await getFromApi("artist");
      console.log(json);
      setResults(json);
    } catch (error) {
      console.log(error);
    }
  }

  const loadMyCollection = async () => {
    try {
      // const res = await fetch(`http://localhost:3000/soundbasket?address=${address}`);
      // const json = await res.json();
      const json = await getFromApi(`soundbasket?address=${address}`)

      setCollection(json);
    } catch (error) {
      console.log(error);
    }
  }


  return (
<div className="mt-20 px-2 m-auto mb-20">
      <div>
        <h1 className="text-3xl font-serif">Discover</h1>
      </div>
      <div className="mt-12 max-w-lg mx-auto grid gap-5 grid-cols-2 lg:max-w-none">        
        {
          results.map(c => {
            const collected = collection.find(m => m.nftName === c.nftName);
            return(
              <div key={c.name} className="flex flex-col rounded-lg border border-gray-300 overflow-hidden">
              {collected && <span key={collected.name} className="text-xs absolute bg-black p-2 text-white rounded-lg mt-2 ml-2">Collected</span>}
              <div className="flex-shrink-0">
                <img className="h-48 w-full object-cover" src={c.nftImage} alt="" />
              </div>
              <div className="text-center flex-1 bg-white py-2 flex flex-col justify-between">
                <div className="flex-1">                
                  <Link to={`/@${c.username}`} className="block">
                    <p className="text-md font-semibold font-serif">{c.nftName}</p>
                    <p className="text-base text-gray-500">{c.name}</p>
                  </Link>
                </div>
              </div>
            </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default Discover